import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, SubCard, SubCardContainer, SubCardTitle, SessionsContainer, RightAlignedButton } from "../../common_components/Layout";
import { SessionStat } from "../../common_components/Analytics";
import { PrimaryButton, SecondaryButton } from "../../common_components/Buttons";
import { SessionHighlightUpcoming } from "../../common_components/SessionHighlights";
import DateFormatting from "../../common_components/DateFormatting";

// Api Calls
import ScheduledEventAPI from "../../../api/api_calls/ScheduledEventAPI";
import MissionUserListsAPI from "../../../api/api_calls/MissionUserListsAPI";
import { get } from "lodash";


function SchedulingCard(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [availableSlotsCount, setAvailableSlotsCount] = useState(-1);
    const [lastAvailableDay, setLastAvailableDay] = useState("");
    const [timezone, setTimezone] = useState("");

    const missionReviewable = props.mission.requires_researcher_review || false
    const [loadingReview, setLoadingReview] = useState(true);
    const [usersToReviewCount, setUsersToReviewCount] = useState(null);
    const [usersToReview, setUsersToReview] = useState([]);


    const mockedCompletedSessions = [
        {
            date: "Wednesday, Sept 2nd",
            time: "4:30 PM",
            name: "Karen",
            id: 1
        },
        {
            date: "Monday, Aug 31st",
            time: "11:30 AM",
            name: "Jack",
            id: 2
        },
        {
            date: "Friday, Aug 28th",
            time: "4:30 PM",
            name: "Ani",
            id: 3
        },

    ]

    useEffect(() => {
        async function getUpcomingSessionsAndStats() {
            const result = await ScheduledEventAPI.one_mission_upcoming_events_and_stats(missionId, navigate);

            if (result.success) {
                setUpcomingEvents(result.upcoming_events)
                setAvailableSlotsCount(result.available_slots_count)
                const [lastDate, lastTime] = DateFormatting.parseISOStringToReadableDateAndTime(result.last_slot_time, result.timezone);
                setLastAvailableDay(lastDate)
                setTimezone(result.timezone)
                setLoadingEvents(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        async function getUsersForReview() {
            const result = await MissionUserListsAPI.review_users({ missionId, handleRedirect: navigate });

            if (result.success) {
                setUsersToReview(result.users_to_review)
                setUsersToReviewCount(result.users_to_review ? result.users_to_review.length : 0)
                setLoadingReview(false);
            } else {
                // Don't show an error here, as this endpoint returns a bad result. 
            }
        }

        getUpcomingSessionsAndStats();
        getUsersForReview();
    }, []);

    const noEventsPlaceholder = (<div className="no-events-placeholder"> No upcoming sessions </div>)

    const upcomingEventsList = (upcomingEvents.map((session) => {
        return (
            <SessionHighlightUpcoming session={session} timezone={timezone} key={"session-" + session.id} onClick={() => navigate("/missions/" + missionId + "/sessions/" + session.id)} />
        )
    }));

    const upcomingEventsSwitch = (upcomingEvents.length > 0 ? upcomingEventsList : noEventsPlaceholder)

    return (
        <Card>
            <GrayCardTitle title="Scheduling" />
            <SubCardContainer>

                <SubCard loading={loadingEvents}>
                    <SubCardTitle>
                        Upcoming Sessions
                    </SubCardTitle>
                    <SessionsContainer>
                        {upcomingEventsSwitch}
                    </SessionsContainer>
                    <RightAlignedButton>
                        <SecondaryButton onClick={() => navigate("/missions/" + missionId + "/upcomingsessions")} text="View all" submitLoading={props.submitLoading} />
                    </RightAlignedButton>
                </SubCard>
                <div className="vertical-card-container">
                    {missionReviewable &&
                        <SubCard loading={loadingReview} pinkBorder={usersToReviewCount > 0}>
                            <SubCardTitle>
                                Users to Review
                            </SubCardTitle>
                            <div className="scheduling-stats-container">
                                <div className="slots-available-text">
                                    {usersToReviewCount == 0 ?
                                        "No users waiting for approval"
                                        :
                                        <><span className="pink-text"> <span style={{ fontWeight: 700 }}>{usersToReviewCount}</span> users </span> waiting for approval</>
                                    }
                                </div>
                            </div>
                            <RightAlignedButton>
                                {usersToReviewCount == 0 ?
                                    <SecondaryButton onClick={() => navigate("/missions/" + missionId + "/reviewusers")} text="Review" submitLoading={props.submitLoading} />
                                    :
                                    <PrimaryButton onClick={() => navigate("/missions/" + missionId + "/reviewusers")} text="Review" submitLoading={props.submitLoading} />
                                }
                            </RightAlignedButton>

                        </SubCard>
                    }
                    <SubCard loading={loadingEvents}>
                        <SubCardTitle>
                            Scheduling Details
                        </SubCardTitle>
                        <div className="scheduling-stats-container">
                            <div className="slots-available-text">
                                <span style={{ fontWeight: 700 }}>{availableSlotsCount}</span> time slots available
                            </div>
                            <div className="slots-available-sub-text">
                                {availableSlotsCount > 0 ? ("Through " + lastAvailableDay) : "Add more time slots"}
                            </div>
                        </div>
                        <RightAlignedButton>
                            <PrimaryButton onClick={() => navigate("/missions/" + missionId + "/scheduling")} text="Manage" submitLoading={props.submitLoading} />
                        </RightAlignedButton>

                    </SubCard>
                </div>

            </SubCardContainer>
        </Card>

    )
}



export default SchedulingCard;